module.exports = __webpack_public_path__ + "static/media/children.b1722196.jpg";